module.exports = __webpack_public_path__ + "img/image04_sp.ceb77c10.jpg";